import { removeObjectFields } from "utils/util";
import api from "./api";
import { GenericResponse, ClientProfile } from "./types";

interface ClientProfileResponse
  extends Omit<ClientProfile, "status">,
    Omit<GenericResponse, "status"> {
  status: number | string;
}

export const createClientAccount = async (data: any) => {
  return (await api.post<ClientProfileResponse>(
    `/api/user/admin/client-account`,
    data
  )) as ClientProfileResponse;
};

export const editClient = async (
  endpoint: string,
  data: any,
  fieldsToRemove: string[]
) => {
  data = removeObjectFields(data, fieldsToRemove);
  return (await api.put<ClientProfileResponse>(
    `${endpoint}`,
    data
  )) as ClientProfileResponse;
};
